import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Button, Confirm } from 'semantic-ui-react'
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import { reduxForm, getFormValues, Field } from 'redux-form'
import { lower } from 'change-case'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { createAdminUser, updateAdminUser, markEndAdminUser, deleteAdminUser } from 'ducks/system'
import { getHrmsMembers, getAllMembers } from 'ducks/member'
import r from 'reactotron-react-js'

const AdminUserModal = (props) => {
  const { valueForm, setShowModal, members, memberLoading } = props

  useEffect(() => {
    if (!members.length) {
      // props.getHrmsMembers()
      props.getAllMembers()
    }
  }, [])

  const [showConfirmDelete, setShowConfirmDelete] = useState(false)
  const [showConfirmEnd, setShowConfirmEnd] = useState(false)

  const memberOptions = members.map(m => ({ value: lower(m.username), text: `${m.firstnameEn} ${m.lastnameEn}` }))

  return (
    <Dialog open={true} className='dialog-full-height' maxWidth='lg' fullWidth style={{ zIndex: 10 }}>
      <DialogTitle>Admin User</DialogTitle>
      <DialogContent>
        <form>
          <Field 
            name='username' 
            label='User' 
            require
            loading={memberLoading}
            options={memberOptions} 
            type={type.select}
            component={FieldInput} />
          <div style={{ display: 'flex' }}>
            <Field name='effectiveDateStart' label='Effective From' type={type.dateTime} component={FieldInput} />
            <Field name='effectiveDateEnd' label='Effective To' type={type.dateTime} component={FieldInput} />
          </div>
          <Field name='note' label='Note' type={type.textArea} component={FieldInput} />
        </form>
      </DialogContent>
      <DialogActions>
        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', padding: '0px 15px' }} >
          <div>
            {
              valueForm.id ? 
                <Button
                  type='button'
                  content='Delete'
                  color='red'
                  icon='trash alternate'
                  labelPosition='right'
                  style={{ marginRight: '5px' }}
                  onClick={() => setShowConfirmDelete(true) }
                /> : null
            }
            {
              valueForm.status === 'Active' ?
                <Button
                  type='button'
                  content='Set End Effective Now'
                  color='orange'
                  icon='calendar times outline'
                  labelPosition='right'
                  style={{ marginRight: '5px' }}
                  onClick={() => setShowConfirmEnd(true) }
                /> : null
            }
          </div>
          <div>
            {
              valueForm.id ? 
                <Button
                  type='button'
                  content='Update'
                  color='blue'
                  icon='save'
                  labelPosition='right'
                  style={{ marginRight: '5px' }}
                  onClick={() => props.updateAdminUser(valueForm, () => setShowModal(false)) }
                /> : 
                <Button
                  type='button'
                  content='Create'
                  color='blue'
                  icon='paper plane outline'
                  labelPosition='right'
                  style={{ marginRight: '5px' }}
                  onClick={() => props.createAdminUser(valueForm, () => setShowModal(false))}
                />
            }
            <Button
              type='button'
              content='Cancel'
              color='red'
              icon='times'
              labelPosition='right'
              style={{ marginRight: '5px' }}
              onClick={() => setShowModal(false)}
            />
          </div>
        </div>
      </DialogActions>
      <Confirm 
        open={showConfirmDelete}
        content='Are you sure to Delete this user.'
        onConfirm={() => props.deleteAdminUser(
          valueForm.id, 
          () => {
            setShowConfirmDelete(false)
            setShowModal(false)
          })
        }
        onCancel={() => setShowConfirmDelete(false)}
      />
      <Confirm 
        open={showConfirmEnd}
        content='Are you sure to end effective this user.'
        onConfirm={() => props.markEndAdminUser(
          valueForm.id, 
          () => {
            setShowConfirmEnd(false)
            setShowModal(false)
          })
        }
        onCancel={() => setShowConfirmEnd(false)}
      />
    </Dialog>
  )
}

const mapStateToProps = (state, props) => {
  const { data } = props
  const editData = data || {}
  const valueForm = getFormValues('adminUserForm')(state) || {}
  
  return ({
    initialValues: {
      id: editData.id,
      username: editData.username,
      effectiveDateStart: editData.effectiveDateStart,
      effectiveDateEnd: editData.effectiveDateEnd,
      note: editData.note,
      status: editData.status
    },
    valueForm: valueForm,
    members: state.member.members,
    memberLoading: state.member.memberLoading,
  })
}

const mapDispatchToProps = {
  createAdminUser,
  updateAdminUser,
  markEndAdminUser, 
  deleteAdminUser,
  getHrmsMembers,
  getAllMembers
}

const AdminUserModalForm = reduxForm({
  form: 'adminUserForm',
  enableReinitialize: true,
})(AdminUserModal)

export default connect(mapStateToProps, mapDispatchToProps)(AdminUserModalForm)